export const URLS = {
  AUTH_EMPLOYEE_MANAGEMENT: '/employeeManagement/employees',
  AUTH_EMPLOYEE_MANAGEMENT_DETAILS: '/employeeManagement/employees/:id'
}

export enum PermissionRoles {
  GG_RO_DEX_EMPLOYEE_MANAGEMENT_ADMIN = 'GG_RO_DEX_EMPLOYEE_MANAGEMENT_ADMIN',
  GG_RO_DEX_EMPLOYEE_MANAGEMENT_USER = 'GG_RO_DEX_EMPLOYEE_MANAGEMENT_USER'
}

export const roles = {
  editRoles: [PermissionRoles.GG_RO_DEX_EMPLOYEE_MANAGEMENT_ADMIN]
}
